<div class="sidebar-menu">
  <div class="container mt-4">
    <ul class="list-unstyled">
      <li *ngFor="let category of (filters | keyvalue)">
        <ul class="list-unstyled">
          <li class="fw-bold">{{category.key.replace('_',' ')}}</li>
          <li *ngFor="let option of category.value">
            <input type="checkbox" [value]="option" [checked]="selectedFilters[category.key]?.includes(option)" (change)="toggleFilter(category.key, option)"> {{option}}
          </li>
        </ul>
      </li>
    </ul>
    <hr>
    <div class="filter-footer text-center">
      <button class="btn btn-outline-danger mt-3" (click)="applyFilters()">Apply Filters</button>
    </div>
  </div>
</div>
